export const shortWalletAddress = (address: string): string => {
  if (!address || address.length < 10) return address || '—'
  return `${address.slice(0, 6)}…${address.slice(-4)}`
}

export const displayNameOrAddress = (
  name: string | null | undefined,
  address: string
): string => {
  const trimmed = name?.trim()
  if (trimmed) return trimmed
  return shortWalletAddress(address)
}
